if(!customElements.get("gift-card")) {
  customElements.define("gift-card", class GiftCard extends HTMLElement {
    constructor() {
      super();

      this.cardVariants;
      this.cardId = this.dataset.cardId;
      this.cardModal = document.querySelector(".gcp__modal");
      this.addToBagBtn = this.querySelector(".atc-btn");
      // this.modalAddBtn = this.cardModal.querySelector("#cardCheckout");
      // this.sideCart = document.querySelector("side-cart");
      this.init();
    }

    init() {
      if(this.addToBagBtn) {
        this.addToBagBtn.addEventListener("click", this.renderModal.bind(this));
      }
      if(this.cardId) {
        this.cardJsonHTML = this.querySelector(`#card-${this.cardId}`);
        this.cardJson = this.cardJsonHTML ? JSON.parse(this.cardJsonHTML.innerHTML) : null;
      }
    }

    renderModal() {
      const gcModal = this.closest(".gift-card-product-grid").querySelector("gift-card-modal");
      // executes render action only if the variants are available
      if(this.cardJson) {
        // elements required for rendering
        const variants = this.cardJson.variants;
        const images = this.cardJson.media.filter((med) => med.media_type === "image");

        gcModal.renderImage(images);
        gcModal.renderAmtDropdown(variants);

        gcModal.openModal();
      }
    }
  });
}

if(!customElements.get("gift-card-modal")) {
  customElements.define("gift-card-modal", class GiftCardModal extends HTMLElement {
    constructor() {
      super();

      this.addBtn = this.querySelector("#cardCheckout");
      this.sideCart = document.querySelector("side-cart");
      this.imgContainer = this.querySelector(".gcp-image");
      this.amtContainer = this.querySelector("#cardAmount");

      // backup elements for rendering
      this.disclaimer = this.querySelector(".disclaimer");

      this.init();
    }

    init() {
      if(this.addBtn) {
        this.addBtn.addEventListener("click", (event) => this.addGCToCart(event));
      }
      const modalOverlay = this.querySelector(".gcp__overlay"),
            modalClose = this.querySelector("#gcpClose");

      ([modalOverlay, modalClose]).forEach((elm) => {
        elm.addEventListener("click", this.closeModal.bind(this));
      })
    }

    moneyFilter(price) {
      return '' + (price / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    openModal() {
      this.classList.add("gcp--open");
    }
    closeModal() {
      this.classList.remove("gcp--open");
    }
    addGCToCart(event) {
      event.preventDefault();

      const qtyElm = this.querySelector("#cardQuantity");
      const variantElm = this.querySelector("#cardAmount");

      const quantity = qtyElm.value ? qtyElm.value : 0;
      const variant = variantElm.value ? variantElm.value : "";
      console.log("quantity", quantity, variant);
      if(quantity && variant) this.sideCart.handleAddItem(event, event.target, variant, quantity);

      this.closeModal();
    }

    renderImage(images) {
      if(images && images.length > 0) {
        const featuredImage = images[0];
        const disclaimerText = this.disclaimer ? this.disclaimer.innerHTML : "";

        const htmlToRender = `
          <img src="${featuredImage.src}" width="${featuredImage.width}" loading="lazy">
          <div class="disclaimer">${disclaimerText}</div>
        `;

        this.imgContainer.innerHTML = htmlToRender;
      }
    }
    renderAmtDropdown(variants) {
      if(variants && variants.length > 0) {
        const htmlToRender = `
          ${variants.map((variant) => {
            return variant.available ? `
              <option value="${variant.id}">${this.moneyFilter(variant.price)}</option>
            ` : "";
          }).join("")}
        `;

        this.amtContainer.innerHTML = htmlToRender;
      }
    }
  });
}
